export const translations = {
  // Form labels and headings
  'Driver': 'Driver — السائق',
  'Truck': 'Truck — الشاحنة',
  'Remarks': 'Remarks — الملاحظات',
  'Loading Time': 'Loading Time — وقت التحميل',
  'Register New Trip': 'Register New Trip — تسجيل رحلة جديدة',
  'Edit Trip': 'Edit Trip — تعديل الرحلة',
  'Register Trip': 'Register Trip — تسجيل رحلة',

  // Table headers
  'Driver + ID': 'Driver + ID — السائق + الرقم',
  'Registration Time': 'Registration Time — وقت التسجيل',
  'Loading Time Column': 'Loading Time — وقت التحميل',
  'Total Trips': 'Total Trips — إجمالي الرحلات',
  'North Trips': 'North Trips — الرحلات الشمالية',
  'North %': 'North % — النسبة الشمالية',
  'Actions': 'Actions — الإجراءات',

  // Buttons and actions
  '+New Trip': '+New Trip — +رحلة جديدة',
  'Cancel': 'Cancel — إلغاء',
  'Select': 'Select — اختيار',
  'Search': 'Search — بحث',
  'Export': 'Export — تصدير',
  'Filter': 'Filter — تصفية',

  // Placeholders and messages
  'Click to select driver': 'Click to select driver — انقر لاختيار السائق',
  'Click to select truck': 'Click to select truck — انقر لاختيار الشاحنة',
  'Enter any remarks...': 'Enter any remarks... — أدخل أي ملاحظات...',
  'No drivers found': 'No drivers found — لم يتم العثور على سائقين',
  'No trucks found': 'No trucks found — لم يتم العثور على شاحنات',
  // New translations
  'Driver locked': 'Driver locked — السائق مقفل',
  'Filter Trips': 'Filter Trips — تصفية الرحلات',
  'Loading trips...': 'Loading trips... — يتم تحميل الرحلات...',
  'No trips found': 'No trips found — لم يتم العثور على رحلات',
  'No trips match your search criteria': 'No trips match your search criteria — لا توجد رحلات تطابق معايير البحث الخاصة بك',
  'Get started by adding your first trip registration': 'Get started by adding your first trip registration — ابدأ بإضافة تسجيل رحلتك الأولى',
  'Add First Trip': 'Add First Trip — أضف الرحلة الأولى',
  'Registering...': 'Registering... — يتم التسجيل...',
  'Go back': 'Go back — العودة',
};
